var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 7,
    r: 6.5,
    fill: "#E7F0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77524 4.27524C3.93389 4.11659 4.19111 4.11659 4.34976 4.27524L6.5 6.42548L8.65024 4.27524C8.80889 4.11659 9.06611 4.11659 9.22476 4.27524C9.38341 4.43389 9.38341 4.69111 9.22476 4.84976L7.07452 7L9.22476 9.15024C9.38341 9.30889 9.38341 9.56611 9.22476 9.72476C9.06611 9.88341 8.80889 9.88341 8.65024 9.72476L6.5 7.57452L4.34976 9.72476C4.19111 9.88341 3.93389 9.88341 3.77524 9.72476C3.61659 9.56611 3.61659 9.30889 3.77524 9.15024L5.92548 7L3.77524 4.84976C3.61659 4.69111 3.61659 4.43389 3.77524 4.27524Z",
    fill: "#3884FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.c7fac4d3de9155c1a87467d56992e58d.svg";
export { ForwardRef as ReactComponent };